<script lang="ts" setup>
import { useCheckoutStore } from '@stores/checkout'

import { AppLogoDomain } from '@UI/Logos/AppLogoDomain'
import { LoaderBlockDomain } from '@UI/Loaders/LoaderBlockDomain'
import { LoaderFullScreenDomain } from '@UI/Loaders/LoaderFullScreenDomain'

defineOptions({
  name: 'LayoutUpsell',
})

const checkoutStore = useCheckoutStore()

</script>

<template>
  <div class="cs-upsell">
    <LoaderFullScreenDomain v-if="!checkoutStore.isOrderId" />
    <template v-else>
      <div class="cs-upsell__header">
        <AppLogoDomain />
        <div class="cs-upsell__status">
          <slot name="status" />
        </div>
      </div>
      <div class="cs-upsell__body">
        <div class="cs-upsell__main">
          <div
            v-if="checkoutStore.isLoading || checkoutStore.isUpsellOrderProcessing"
            class="cs-upsell__loader"
          >
            <LoaderBlockDomain />
          </div>
          <div class="cs-upsell__content">
            <slot />
          </div>
          <div class="cs-upsell__offer">
            <slot name="offer" />
          </div>
          <div class="cs-upsell__actions">
            <slot name="actions" />
          </div>
        </div>
        <div class="cs-upsell__aside">
          <slot name="aside" />
        </div>
      </div>
    </template>
  </div>
  <slot
    v-if="$slots.modals"
    name="modals"
  />
</template>

<style scoped lang="scss" src="@scss/layouts/upsell.scss" />
